import store from '../store'
import getLoggedUser from './get-logged-user'
import { getUrlParameter } from './index'

/**
 * Set logged user to store
 *
 * @param {Object} data          - access token data, ex:  {access_token: XXX, refresh_token: YYY, ...}
 * @param {null|string|boolean} redirect      - reload page (NULL), redirect to specific page (STRING) or not redirect (FALSE)?
 * @param {boolean} saveToStorage - save access token to storage? If false, login will not be applied permanently
 * @return {Promise}
 */
export default (data, redirect = null, saveToStorage = true) => {
    if (saveToStorage) {
        localStorage.removeItem('sportnect.tokens')
        localStorage.setItem('sportnect.tokens', JSON.stringify(data))
    }

    window.axios.defaults.headers.common.Authorization = `Bearer ${data.access_token}`

    return getLoggedUser().then(() => {
        store.dispatch({ type: 'CLEAR_LOGIN_ERROR' })
        store.dispatch({
            type: 'TOGGLE_BUSY_SECTION',
            section: 'login',
        })

        if (redirect !== false) {
            if (typeof redirect === 'function') {
                redirect(data)
            } else {
                if (redirect) {
                    window.location.href = redirect
                } else {
                    window.location.reload()
                }
            }
        }
    }).catch(err => {
        if (getUrlParameter('access_token')) {
            window.location = window.location.href.split('?')[0]
        }

        if (err.response) {
            store.dispatch({
                type: 'SET_LOGIN_ERROR',
                error: err.response.data.error,
            })
        }

        store.dispatch({
            type: 'TOGGLE_BUSY_SECTION',
            section: 'login',
        })
    })
}
